import React from 'react';
import {
  useHistory
} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { CheckCircleRounded } from '@material-ui/icons';


import Logo from './assets/logo.png';
import Banner from './assets/banner.jpg';
import Secure from './assets/secure.png';
import Free from './assets/free.png';
import Easy from './assets/easy.png';


const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',

  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidth: 1140,
    paddingLeft: 15,
    paddingRight: 15,
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 12,
      paddingRight: 12,
    },
  },
  button: {
    textTransform: 'none',
    height: 44,
    paddingLeft: 35,
    paddingRight: 35,
    marginLeft: 24,
    [theme.breakpoints.down('xs')]: {
      height: 36,
      paddingLeft: 8,
      paddingRight: 8,
      fontSize: 12,
      marginLeft: 10,
    },
  },
  logo: {
    position: 'relative',
    top: 16,
  },
  logoImage: {
    height: 73,
    [theme.breakpoints.down('xs')]: {
      height: 52,
    },
  },
  nav: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 80,
    [theme.breakpoints.down('xs')]: {
      height: 65,
    },
    // paddingTop: 20,
    // paddingBottom: 20,
  },
  navButton: {
    paddingLeft: 10,
    paddingRight: 10,
    marginLeft: 10,
    marginRight: 10,
    textTransform: 'none',
    height: 45,

  },
  bannerButton: {
    paddingLeft: 34,
    paddingRight: 34,
    marginRight: 24,
    height: 50,
    [theme.breakpoints.down('xs')]: {
      margin: 12,
      marginRight: 12,
    },
  },

  banner: {
    backgroundImage: `url(${Banner}) `,
    backgroundPosition: 'bottom',
    height: 660,
    maxWidth: 1366,
    margin: '0 auto',
    [theme.breakpoints.down('xs')]: {
      backgroundPosition: '15% 0%',
      height: 684,
    },
  },
  bannerWraper: {
    maxWidth: 1140,
    paddingLeft: 15,
    paddingRight: 15,
    margin: '0 auto',
    paddingTop: 120,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      paddingLeft: '4%',
      paddingRight: '4%',
      paddingTop: 60,
    },
  },
  bannerContent: {
    width: 550,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      textAlign: 'center',
      // paddingLeft: '4%',
      // paddingRight: '4%',
      // paddingTop: 60,
    },
  },
  bannerText1: {
    fontSize: 23,
    color: '#FFF',
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
    },
  },
  bannerText2: {
    fontSize: 38,
    color: '#FFF',
    fontWeight: 600,
    marginTop: 40,
    [theme.breakpoints.down('xs')]: {
      fontSize: 34,
      lineHeight: 1.3,
    },
  },
  bannerText3: {
    fontSize: 16,
    color: '#FFF',
    width: 410,
    marginTop: 25,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      fontSize: 15,
    },
  },
  bannerText4: {
    fontSize: 16,
    color: '#FFF',
    fontWeight: 600,
    marginBottom: 45,
    marginTop: 15,
    [theme.breakpoints.down('xs')]: {
      marginBottom: 30,
      fontSize: 15,
    },
  },
  bannerBrandName: {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
  section1: {
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 50,
    paddingBottom: 150,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 0,
      paddingBottom: 60,
    },
  },
  section1Content: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 750,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      paddingLeft: '5%',
      paddingRight: '5%',
    },
  },
  sectionTitle: {
    textAlign: 'center',
    fontWeight: 700,
    marginTop: 90,
    marginBottom: 20,
    fontSize: 40,
    [theme.breakpoints.down('xs')]: {
      marginTop: 60,
      fontSize: 33,
    },
  },
  section1Icon: {
    fontSize: 130,
    [theme.breakpoints.down('xs')]: {
      fontSize: 110,
      marginBottom: 10,
      marginTop: 10,
    },
  },
  section1Ul: {
    '& > li': {
      fontSize: 17,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
    }

  },
  section2: {
    backgroundColor: '#F2F2F2',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 100,
    paddingBottom: 100,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 70,
      paddingBottom: 90,
    },
    // height: 584,
  },
  section2TextContainer: {
    marginTop: 20,
    maxWidth: 550,
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '10%',
      paddingRight: '10%',
      marginTop: 40,
    },
  },
  section2SubTitle: {
    marginBottom: -40,
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      marginBottom: 0,
    },
  },
  section2Text: {
    fontSize: 17,
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
    },
  },
  section2Button: {
    paddingLeft: 30,
    paddingRight: 30,
    height: 50,
    fontSize: 17,
    marginTop: 45
  },
  section3: {
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 50,
    [theme.breakpoints.down('xs')]: {
      paddingTop: 10,
    },
  },
  section3Container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 110,
    marginTop: 40,
    maxWidth: 1140,
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginBottom: 40,
    },
  },
  section3Image: {
    height: 50,
  },
  section3SectionTItle: {
    fontWeight: 600,
    fontSize: 19,
    textAlign: 'center',
    marginTop: 25,
    marginBottom: 8,
    [theme.breakpoints.down('xs')]: {
      fontSize: 18
    },
  },
  section3Section: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 210,
    flex: 1,
    // maxWidth: 350,
    paddingLeft: 20,
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      marginBottom: 50,
    },
  },
  section3Text: {
    fontSize: 18,
    textAlign: 'center',
    lineHeight: 1.3,
    [theme.breakpoints.down('xs')]: {
      height: 'auto',
      fontSize: 18,
    },
  },
  section4: {
    backgroundColor: '#F2F2F2',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '8%',
      paddingRight: '8%',
    },

    // height: 584,
  },
  section4TextContainer: {
    maxWidth: 950,
    textAlign: 'center',
    marginTop: 30,
    marginBottom: 90,
  }
}));


const NAV = [
  {
    name: 'Home',
    link: '/',
  },
  {
    name: 'POS',
    link: '/',
  },
  {
    name: 'Management',
    link: '/',
  },
  {
    name: 'Marketing',
    link: '/',
  },
  {
    name: 'Payment',
    link: '/',
  },
  {
    name: 'Contact Us',
    link: '/',
  },
]

const Home = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.logo}>
          <img alt="guestbook.linkpos.com.au" src={Logo} className={classes.logoImage} />
        </div>
        {((localStorage.getItem('accessToken') && localStorage.getItem('storeId'))) ?

        <div className={classes.nav}>
          {/* {NAV.map(item => <Button className={classes.navButton} key={item.name}>{item.name}</Button>)} */}
          <Button onClick={() => history.push('/admin/regisiterrecords')} className={classes.button} variant="contained" color="primary" disableElevation>Management Center</Button>
        </div>
        :
        <div className={classes.nav}>
        {/* {NAV.map(item => <Button className={classes.navButton} key={item.name}>{item.name}</Button>)} */}
        <Button onClick={() => history.push('/regisiter')} className={classes.button} variant="contained" color="primary" disableElevation>Regisiter for free</Button>
        <Button onClick={() => history.push('/login')} className={classes.button} variant="outlined" color="secondary" disableElevation>Login</Button>

      </div>
        }
      </div>

      <div className={classes.banner}>
        <div className={classes.bannerWraper}>
          <div className={classes.bannerContent}>
            <Typography variant="h6" component="h1" className={classes.bannerText1}>
              THIS IS <span className={classes.bannerBrandName}>GUESTBOOK</span>
            </Typography>
            <Typography variant="h1" component="h3" className={classes.bannerText2}>
              Registration compliance made easy. And free.
          </Typography>
            <Typography variant="body1" component="h4" className={classes.bannerText3}>
              A free QR code system that allows you to collect data from every customer, quickly and securely for contact tracing and COVID-19 compliance.
          </Typography>
            <Typography variant="body1" component="h5" className={classes.bannerText4}>
              And your customers don’t need an app to use it.
          </Typography>
            <div>
              <Button onClick={() => history.push('/regisiter')} className={classes.bannerButton} variant="contained" color="primary" disableElevation>Regisiter for free</Button>
              <Button className={classes.bannerButton} variant="outlined" color="primary" disableElevation>Talk To Our Team</Button>
            </div>
          </div>
        </div>
      </div>


      <div className={classes.section1}>
        <Typography variant="h3" component="h6" className={classes.sectionTitle}>
          GuestBook meets<br />government requirements.
          </Typography>
        <div className={classes.section1Content}>
          <CheckCircleRounded htmlColor='#0DDD7E' className={classes.section1Icon} />
          <ul className={classes.section1Ul}>
            <li>digitally collecting customer’s name, mobile and email</li>
            <li>storing it securely</li>
            <li>keeping for the 28-day minimum</li>
            <li>providing a downloadable report from our management centre to hand over if requested for contact tracing</li>
          </ul>
        </div>
      </div>

      <div className={classes.section2}>
        <Typography variant="h5" component="h6" className={classes.section2SubTitle}>
          GET STARTED WITH <span style={{ fontWeight: 600 }}>GUESTBOOK</span>
        </Typography>
        <Typography variant="h3" component="h6" className={classes.sectionTitle}>
          Easy as 1, 2, 3.
          </Typography>
        <div className={classes.section2TextContainer}>
          <Typography variant="body1" component="h6" className={classes.section2Text}>
            <span style={{ fontWeight: 600 }}>1.</span>	Register for your unique QR code
        </Typography>
          <Typography variant="body1" component="h6" className={classes.section2Text}>
            <span style={{ fontWeight: 600 }}>2.</span>	Print and display the QR code, along with a short message
        </Typography>
          <Typography variant="body1" component="h6" className={classes.section2Text}>
            <span style={{ fontWeight: 600 }}>3.</span>	Access and print your list easily in the management centre if requested
        </Typography>
        </div>
        <Button onClick={() => history.push('/regisiter')} className={classes.section2Button} variant="contained" color="primary" disableElevation>Regisiter for free</Button>

      </div>

      <div className={classes.section3}>
        <Typography variant="h3" component="h6" className={classes.sectionTitle}>
          Why Choose GuestBook?
          </Typography>
        <div className={classes.section3Container}>
          <div className={classes.section3Section}>
            <img alt="free" src={Free} className={classes.section3Image} />
            <Typography variant="h6" component="h6" className={classes.section3SectionTItle}>
              FREE
            </Typography>
            <Typography variant="h3" component="h6" className={classes.section3Text}>
              For you and<br />your customer
            </Typography>
          </div>
          <div className={classes.section3Section}>
            <img alt="secure" src={Secure} className={classes.section3Image} />
            <Typography variant="h6" component="h6" className={classes.section3SectionTItle}>
              SECURE
            </Typography>
            <Typography variant="h3" component="h6" className={classes.section3Text}>
              All data is securely encrypted<br />and stored for you and your<br />customers’ peace of mind
            </Typography>
          </div>
          <div className={classes.section3Section}>
            <img alt="easy" src={Easy} className={classes.section3Image} />
            <Typography variant="h6" component="h6" className={classes.section3SectionTItle}>
              EASY
            </Typography>
            <Typography variant="h3" component="h6" className={classes.section3Text}>
              No app required, and details<br />can be entered contact-free<br />within seconds
            </Typography>
          </div>

        </div>
      </div>

      <div className={classes.section4}>
        <Typography variant="h3" component="h6" className={classes.sectionTitle}>
          Who runs GuestBook?
          </Typography>
        <div className={classes.section4TextContainer}>
          <Typography variant="body1" component="h6" className={classes.section2Text} style={{}}>
            <span style={{ fontWeight: 600 }}>GuestBook is brought to you by Link Group, an established and trusted point of sale system provider to many hospo partners across Australia.</span><br /><br />Our system has been using QR codes for many years to provide seamless ordering for a range of cafes, pubs, restaurants and food courts. It only seemed natural to use our technology to help business owners and managers comply with new and changing government regulations around public health.<br /><br />The details collected through GuestBook will only be used for contact tracing purposes and purged after 28 days. We offer data collection tools for the purpose of business operations and marketing through other products.
        </Typography>
          <Button onClick={() => history.push('/regisiter')} className={classes.section2Button} variant="contained" color="primary" disableElevation>Regisiter for free</Button>
        </div>

      </div>

    </div>
  );
};

export default Home;